/**
 * Maps web dashboard section keys (from byzantine's
 * `WEB_DASHBOARD_SECTIONS_LEFT` / `WEB_DASHBOARD_SECTIONS_RIGHT`) to the FTL
 * message ids used for their human-readable labels. Used both for the row
 * text rendered in the customization dialog and for screen-reader drag
 * announcements.
 */
const SECTION_LABELS_TO_FLUENT_IDS: Record<string, string> = {
  marketing_banner_image:
    "dashboard-customization-section-marketing-banner-image",
  accounts: "dashboard-customization-section-accounts",
  recent_transactions: "dashboard-customization-section-recent-transactions",
  card_offers: "dashboard-customization-section-card-offers",
  account_totals: "dashboard-customization-section-account-totals",
  chart_card: "dashboard-customization-section-chart-card",
  credit_monitoring: "dashboard-customization-section-credit-monitoring",
  external_accounts: "dashboard-customization-section-external-accounts",
  verify_external_accounts:
    "dashboard-customization-section-verify-external-accounts",
  marketing_card: "dashboard-customization-section-marketing-card",
  services: "dashboard-customization-section-services",
  subscriptions: "dashboard-customization-section-subscriptions",
  marketing_card_image: "dashboard-customization-section-marketing-card-image",
};

export default SECTION_LABELS_TO_FLUENT_IDS;
